import { render, staticRenderFns } from "./scatter.vue?vue&type=template&id=7f5bdafa&"
import script from "./scatter.vue?vue&type=script&lang=js&"
export * from "./scatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports